import script from "./CreditCard48.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreditCard48.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__